import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from "rxjs";
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { selectTechnicianAssigned, selectTechnician, selectSearchFailedGetByCode } from 'src/app/store/user/user.selector';
import { User } from 'src/app/model/user';
import * as UserActions from 'src/app/store/user/user.actions';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './technician-add.dialog.component.html',
})

export class TechnicianAddDialogComponent implements OnInit, OnDestroy {
	technician$: Observable<User | undefined>;
	technicianSub: Subscription | undefined;
	technicianAssigned$: Observable<boolean | undefined>;
	technicianAssignedSub: Subscription | undefined;

	addTechnicianForm: FormGroup;

	technician: User;

	searchFailed: boolean;
	searchFailed$: Observable<boolean | undefined>;
	searchFailedSub: Subscription | undefined;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
	}

	buildForm(): void {
		this.addTechnicianForm = new FormGroup({
			'technicianCode': new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(8)]),
		});
	}

	initSelectors(): void {
		// Store selectors
		this.technician$ = this.store.select(selectTechnician);
		this.technicianAssigned$ = this.store.select(selectTechnicianAssigned);
		this.searchFailed$ = this.store.select(selectSearchFailedGetByCode);
	}

	subscribeAll(): void {
		this.technicianSub = this.technician$?.subscribe(
			(technician) => {
				this.technician = technician;
			}
		);
		this.technicianAssignedSub = this.technicianAssigned$?.subscribe(
			(addSuccess) => {
				if (addSuccess) {
					this.ref.close('success');
				}
			}
		);
		this.searchFailedSub = this.searchFailed$.subscribe(
			(searchFailed) => {
				this.searchFailed = searchFailed;
			}
		)
	}

	ngOnDestroy(): void {
		this.technicianSub?.unsubscribe();
		this.technicianAssignedSub?.unsubscribe();
		this.searchFailedSub?.unsubscribe();
	}

	findTechnician(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			const code = this.f.technicianCode.value;
			if (code.length > 5 && code.length < 9) {
				this.store.dispatch(UserActions.getTechnicianByCode({ code }));
			}
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.addTechnicianForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.addTechnicianForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		const code = this.f.technicianCode.value;
		if (this.technician) {
			this.store.dispatch(UserActions.assignTechnicianToUser({ techCode: code }));
		}
	}

	get f(): any {
		return this.addTechnicianForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	newShowErrors(type: TechnicianAddDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	justifyMessagesNewValidator(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	showErrorRequiredMessage(type: TechnicianAddDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}
}
